export function stringify(object, options = {}) {
    const { sort = false, excludeEmpty = false } = options;
    const searchParams = new URLSearchParams();
    Object.entries(object).forEach(([key, value]) => {
        if (excludeEmpty && !value) {
            return;
        }
        searchParams.set(key, value);
    });
    if (sort) {
        searchParams.sort();
    }
    return searchParams.toString();
}
